import { Config } from "../types/config";

export const getConfigFromCache = (): Config | undefined => {
  if (typeof window === "undefined") {
    return;
  }

  const configFromCache: {
    config: Config;
  } | null = JSON.parse(
    window.sessionStorage.getItem("reactify-search:config") ?? "null"
  );

  if (configFromCache) {
    if (configFromCache.config.cache?.enabled === false) {
      return;
    }

    return configFromCache.config;
  }

  return;
};

export const getConfigFromNetwork = async (shopifyPermanentDomain: string): Promise<Config | undefined> => {
  let configFromNetwork: Config | undefined;
  try {
    configFromNetwork = (await fetch(
      `https://config.usereactify.com/?shop=${shopifyPermanentDomain}`
    ).then((response) => response.json()))?.body;
    
  } catch (error) {
    configFromNetwork = (await fetch(
      `https://config.usereactify.com/?shop=${shopifyPermanentDomain}`
    ).then((response) => response.json()))?.body;
  }

  return configFromNetwork;
};

export const getConfig = async (shopifyPermanentDomain: string): Promise<Config> => {
  const configFromCache = getConfigFromCache();
  if (configFromCache) {
    return configFromCache;
  }

  const configFromNetwork = await getConfigFromNetwork(shopifyPermanentDomain);

  if (!configFromNetwork) {
    throw new Error("Unable to load config");
  }

  if (typeof window !== "undefined") {
    window.sessionStorage.setItem(
      "reactify-search:config",
      JSON.stringify({
        config: configFromNetwork,
      })
    );
  }

  return configFromNetwork;
};
